<div class="row">

    <div class="col-sm-10 landing-overview">
    <div class="info-policy"><app-usage></app-usage></div>
    </div>
    <div class="col-sm-2 info-policy-links">
        <ul class="list-group list-group-flush">
            <li class="list-group-item"><a routerLink="" fragment="#intro">Introduction</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#general"> General</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#membership"> Membership</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#open-free-access"> Open Free Access</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#billing"> Billing</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#password-account"> Passwords and Account Access</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#dw-company"> Information about the Company</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#warranties"> Subscriber Warranties, Rights, Representations, Restrictions, and Obligations</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#availability-of-site"> Availability of Website</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#third-party-sites"> Third Party Links or Information</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#disclaimer-warrantee"> Disclaimers of statements/Warranties</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#limited-liability"> Limitation of Liability</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#indemnify"> Indemnity</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#survival"> Survival</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#changes"> Changes</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#assignment"> Assignment</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#injuction"> Injunction</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#severability"> Severability</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#complete-understanding"> Complete Understanding</a></li>
            <li class="list-group-item"><a routerLink="" fragment="#any-questions"> Any Questions</a></li>
        </ul>

    </div>
</div>
